<template>
    <div>
        <div class="title-banner">
            <span class="title">推荐拼团</span>
        </div>
        <van-row gutter="2">
            <van-col span="8" v-for="(item,index) in list" :key="index">
                <sale-group-item :p_info="item" />
            </van-col>
        </van-row>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import SaleGroupItem from "./SaleGroupItem";
    export default {
        name: "SaleGroupList",
        components: {SaleGroupItem},
        data(){
            return{
                list:[],
                loading:false,
            }
        },
        methods:{
            ...mapActions([
                'GetSaleToolGroupRuleList',
            ]),
            load_list(){
                this.loading=true;
                let show_count=9;
                this.GetSaleToolGroupRuleList({show_count}).then(res=>{
                    this.loading=false;
                    this.list=res;
                });
            },
        },
        mounted() {
            this.load_list();
        }
    }
</script>

<style lang="scss" scoped>
    .title-banner{
        padding: 5px;
        text-align: left;
        .title{
            font-size: 14px;
            color: #333333;
            font-weight: bold;
        }
        .help-icon{
            font-size: 18px;
            color: #666666;
            float: right;
        }
    }
</style>
